import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { CurrentDistrictWarehousesSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { WarehousePlacement, WarehousePlacementManipulationViewModel } from "./warehousePlacementManipulation-viewModel"

export class WarehousePlacementManipulationView extends View<WarehousePlacementManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-ABC32CEF-AA97-42DD-A169-60C9A05E9F5B"
    }
    loadHtml(): string {
        let element = require('./warehousePlacementManipulation.html').default;
        let style = require('./warehousePlacementManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehousePlacement(v: ObservableArray<WarehousePlacement>) { this._warehousePlacement = v; } public get warehousePlacement(): ObservableArray<WarehousePlacement> { return this._warehousePlacement;} private _warehousePlacement: ObservableArray<WarehousePlacement>;
    public set warehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: CurrentDistrictWarehousesSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    public set isWarehouseSelected(v: boolean) { this._isWarehouseSelected = v; } public get isWarehouseSelected(): boolean { return this._isWarehouseSelected;} private _isWarehouseSelected: boolean;
    
    export() {
        this.dataContext.export();
    }
    
    setPlacementBatch(){
        this.dataContext.setPlacementBatch();
    }
}
